import React from "react";
import ClayModal, { useModal } from "@clayui/modal";
import ClayButton from "@clayui/button";
import ClayTable from "@clayui/table";
import { IconButton, Table, TablePagination } from "common-ui-modules";

const BitnamiAppInfoModal = ({ rowData, title, handleClose }) => {
    const { observer, onClose } = useModal({
        onClose: handleClose,
    });

    const columnDefs = [
        { headerName: "Updated Time", field: "updatedTime" },
        { headerName: "Updated By", field: "updatedBy" },
    ];

    return (
        <React.Fragment>
            <ClayModal center={"Vertically Center"} observer={observer} size="lg" zIndex={999} status="">
                <div className="d-flex align-items-center justify-content-between">
                    <ClayModal.Header>
                        <strong>{`${title} - Details`}</strong>
                        <IconButton icon="cross" className="dp-popupmodal-cross-icon" onClick={onClose}></IconButton>
                    </ClayModal.Header>
                </div>
                <ClayModal.Body>
                    <ClayTable borderedColumns={true} borderless={true} striped={false} hover={false} className="header-table">
                        <ClayTable.Body>
                            {columnDefs.map((colDef, index) => (
                                <ClayTable.Row key={index}>
                                    <ClayTable.Cell className="title">{colDef.headerName}:</ClayTable.Cell>
                                    <ClayTable.Cell className="content">{rowData[0][colDef.field] || '-'}</ClayTable.Cell>
                                </ClayTable.Row>
                            ))}
                        </ClayTable.Body>
                    </ClayTable>
                </ClayModal.Body>
            </ClayModal>
        </React.Fragment>
    );
};

export default BitnamiAppInfoModal;